export default {
  Name: 'organisation-details__name',
  EmployeeNumber: 'organisation-details__employee-number',
  Role: 'organisation-details__role',
  RotaGroup: 'organisation-rota-group',
  CompanySector: 'organisation-details__company-sector',
  TimeZone: 'organisation-details__time-zone',
  ContinueButton: 'organisation-details__continue-button'
};
